import apiClient from "@services/api/apiClient.jsx";

/**
 * 디자인 관련 API 서비스
 */
const designApi = {
    /**
     * 테마 ID에 따른 페이지 디자인 목록 조회
     * @param {number} themeId 테마 ID
     * @returns {Promise<Array>} 페이지 디자인 목록
     */
    getDesignPages: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/pages`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 페이지 디자인 목록 조회 실패:`, error);
            throw error;
        }
    },

    // 시작 화면 관련 API
    getStartPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/startPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 start page 조회 실패:`, error);
            throw error;
        }
    },

    saveStartPage: async (themeId, startPage) => {
        console.log(JSON.stringify(startPage));
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/startPage`, startPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 start page 저장 실패:`, error);
            return false;
        }
    },

    // 앵글 선택 화면 관련 API
    getAngleSelectPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/angleSelectPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 angle select page 조회 실패:`, error);
            throw error;
        }
    },

    saveAngleSelectPage: async (themeId, angleSelectPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/angleSelectPage`, angleSelectPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 angle select page 저장 실패:`, error);
            return false;
        }
    },

    // 레이아웃 화면 관련 API
    getLayoutPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/layoutPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 layout page 조회 실패:`, error);
            throw error;
        }
    },

    saveLayoutPage: async (themeId, layoutPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/layoutPage`, layoutPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 layout page 저장 실패:`, error);
            return false;
        }
    },

    // 수량 선택 화면 관련 API
    getAmountPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/amountPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 quantity amount 조회 실패:`, error);
            throw error;
        }
    },

    saveAmountPage: async (themeId, amountPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/amountPage`, amountPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 quantity amount 저장 실패:`, error);
            return false;
        }
    },

    // 결제 화면 관련 API
    getPaymentPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/paymentPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 payment page 조회 실패:`, error);
            throw error;
        }
    },

    savePaymentPage: async (themeId, paymentPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/paymentPage`, paymentPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 payment page 저장 실패:`, error);
            return false;
        }
    },

    // 결제 로딩 화면 관련 API
    getPaymentLoadingPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/paymentLoadingPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 payment loading page 조회 실패:`, error);
            throw error;
        }
    },

    savePaymentLoadingPage: async (themeId, paymentLoadingPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/paymentLoadingPage`, paymentLoadingPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 payment loading page 저장 실패:`, error);
            return false;
        }
    },

    // 촬영 대기 화면 관련 API
    getCaptureStandbyPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/captureStandbyPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 capture standby page 조회 실패:`, error);
            throw error;
        }
    },

    saveCaptureStandbyPage: async (themeId, captureStandbyPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/captureStandbyPage`, captureStandbyPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 capture standby page 저장 실패:`, error);
            return false;
        }
    },

    // 촬영 모드 화면 관련 API
    getCapturePage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/capturePage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 capture page 조회 실패:`, error);
            throw error;
        }
    },

    saveCapturePage: async (themeId, capturePage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/capturePage`, capturePage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 capture page 저장 실패:`, error);
            return false;
        }
    },

    // 촬영 후 로딩 화면 관련 API
    getPostCaptureLoadingPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/postCaptureLoadingPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 post capture loading page 조회 실패:`, error);
            throw error;
        }
    },

    savePostCaptureLoadingPage: async (themeId, postCaptureLoadingPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/postCaptureLoadingPage`, postCaptureLoadingPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 post capture loading page 저장 실패:`, error);
            return false;
        }
    },

    // 사진 선택 화면 관련 API
    getPhotoSelectionPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/photoSelectionPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 photo selection page 조회 실패:`, error);
            throw error;
        }
    },

    savePhotoSelectionPage: async (themeId, photoSelectionPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/photoSelectionPage`, photoSelectionPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 photo selection page 저장 실패:`, error);
            return false;
        }
    },

    // 인쇄/다운로드 대기 화면 관련 API
    getPrintWaitingPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/printWaitingPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 print waiting page 조회 실패:`, error);
            throw error;
        }
    },

    savePrintWaitingPage: async (themeId, printWaitingPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/printWaitingPage`, printWaitingPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 print waiting page 저장 실패:`, error);
            return false;
        }
    },

    // QR 뷰어 화면 관련 API
    getQrViewerPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/qrViewerPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 QR viewer page 조회 실패:`, error);
            throw error;
        }
    },

    saveQrViewerPage: async (themeId, qrViewerPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/qrViewerPage`, qrViewerPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 QR viewer page 저장 실패:`, error);
            return false;
        }
    },

    // 모달 화면 관련 API
    getModalPage: async (themeId) => {
        try {
            const response = await apiClient.get(`/designs/pageDesign/${themeId}/modalPage`);
            return response.data;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 modal page 조회 실패:`, error);
            throw error;
        }
    },

    saveModalPage: async (themeId, modalPage) => {
        try {
            const response = await apiClient.post(`/designs/pageDesign/${themeId}/modalPage`, modalPage);
            console.log(response.data);
            return true;
        } catch (error) {
            console.error(`테마 ID ${themeId}의 modal page 저장 실패:`, error);
            return false;
        }
    }
};

export default designApi;